import { REQUIRED_ROLES } from "./rquired-roles";

export const inspectionRequests = {
  path: "/inspection-requests",
  name: "inspectionRequests",
  meta: {
    authorized: true,
    roles: REQUIRED_ROLES['inspection-requests']
  },
  component: () => import("../views/inspection-requests/index.vue"),
  children: [
    {
      path: "",
      name: "inspectionRequestsList",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () => import("../views/inspection-requests/list/index.vue"),
    },
    {
      path: ":id/edit",
      name: "inspectionRequestsEdit",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () => import("../views/inspection-requests/edit/index.vue"),
    },
    {
      path: ":id/details",
      name: "inspectionRequestsDetails",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () => import("../views/inspection-requests/details/index.vue"),
      children: [
        {
          path: "",
          name: "inspectionRequestsDetailsContent",
          meta: {
            authorized: true,
            roles: REQUIRED_ROLES['inspection-requests']
          },
          component: () =>
            import(
              "../views/inspection-requests/details/details-content/index.vue"
            ),
        },
      ],
    },
    {
      path: ":id/results",
      name: "inspectionRequestsResults",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () =>
        import(
          "../views/inspection-requests/details/Short-Checklist/index.vue"
        ),
    },
    {
      path: ":id/certificate",
      name: "inspectionRequestsCertificate",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () =>
        import("../views/inspection-requests/certificate/index.vue"),
    },
    {
      path: ":id/building-certificate",
      name: "buildingCertificate",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () =>
        import("../views/inspection-requests/buildingCertificate/index.vue"),
    },
  ],
};
export const inspectionRequestsV2 = {
  path: "/inspection-requests-v2",
  name: "inspectionRequestsV2",
  meta: {
    authorized: true,
    roles: REQUIRED_ROLES['inspection-requests']
  },
  component: () => import("../views/inspection-requests/index.vue"),
  children: [
    {
      path: "",
      name: "inspectionRequestsListV2",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () => import("../views/inspection-requests/list/index.vue"),
    },
    {
      path: ":id/edit",
      name: "inspectionRequestsEditV2",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () => import("../views/inspection-requests/edit/index.vue"),
    },
    {
      path: ":id/details",
      name: "inspectionRequestsDetailsV2",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () => import("../views/inspection-requests/details/index.vue"),
      children: [
        {
          path: "",
          name: "inspectionRequestsDetailsContentV2",
          meta: {
            authorized: true,
            roles: REQUIRED_ROLES['inspection-requests']
          },
          component: () =>
            import(
              "../views/inspection-requests/details/details-content/index.vue"
            ),
        },
      ],
    },
    {
      path: ":id/results",
      name: "inspectionRequestsResultsV2",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () =>
        import(
          "../views/inspection-requests/details/Short-Checklist/index.vue"
        ),
    },
    {
      path: ":id/certificate",
      name: "inspectionRequestsCertificateV2",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () =>
        import("../views/inspection-requests/certificate/index.vue"),
    },
    {
      path: ":id/building-certificate", 
      name: "buildingCertificateV2",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['inspection-requests']
      },
      component: () =>
        import("../views/inspection-requests/buildingCertificate/index.vue"),
    },
  ],
};